import React from "react";
import Window from "./Window";

import "./ProvablyFairSettings.css";
import ProvablyFair from "./ProvablyFair";

export default class ProvablyFairSettings extends React.Component<ProvablyFairSettings.Props, ProvablyFairSettings.State>
{


    constructor(props: ProvablyFairSettings.Props)
    {
        super(props);
    }


    render()
    {
        const data = window.lang.shared.modals["fairness-settings"];
        const lShared = window.lang.shared;

        return (
            <Window
                title={lShared.provably_fair_settings}
                id="ProvablyFairSettings"
            >

                <div className="description">
                    <p>{data["tooltip"]["text"]}</p>

                    <div className="link" onClick={this.clickRules}>

                        <img src={"gfx/free_bets/question.svg?version=" + version} className="logo" />

                        <p>{lShared.what_is_provably_fair}</p>
                    </div>
                </div>

                <div className="divider"></div>

                <div className="content">
                    <div className="loader"></div>
                </div>

                <div className="footer">
                    <p>{data.bottom}</p>
                </div>

            </Window>
        );
    }

    clickRules()
    {
        app.closeLastWindow();
        app.addWindow(<ProvablyFair />);
    }


}

export namespace ProvablyFairSettings
{
    export interface Props
    {
    }

    export interface State
    {
    }
}